export default __webpack_public_path__ + "static/media/avaterStudent.a4e3f203.svg";